module.exports = __webpack_public_path__ + "media/components/country-flag/static/tc-7179a56c37425840f009eec1913a0444.svg";